module.exports = __webpack_public_path__ + "static/media/bg-windows.647f3bb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-windows.jpg
// module id = 640
// module chunks = 0